import {
	Component,
	ContentChild,
	Input,
	TemplateRef
}                         from '@angular/core';
import { ITagListConfig } from '@shared/components/tag/tag.model';

@Component( {
	selector: 'app-tag-list[tagListConfig]',
	templateUrl: './tag-list.component.html',
	styleUrls: [ './tag-list.component.scss' ]
} )
export class TagListComponent {

	@Input() tagListConfig: ITagListConfig;
	@ContentChild( 'tagListItemTpl', { read: TemplateRef } ) tagListItemTpl: TemplateRef<any>;
}
